/**
 * Cold Water Benefits Accordion
 * 
 * This script handles the accordion functionality for the Cold Water Benefits section.
 * It allows users to click on benefit items to expand/collapse their content.
 */

document.addEventListener('DOMContentLoaded', function() {
  const benefitButtons = document.querySelectorAll('.benefit-button');
  
  // Add click event listener to each benefit button
  benefitButtons.forEach(button => {
    button.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains('active');
      
      // Close all accordions
      benefitButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.nextElementSibling.style.maxHeight = '0';
      });
      
      // If the clicked accordion wasn't active, open it
      if (!isActive) {
        this.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Optional: Open the first accordion item by default
  // Uncomment the following lines to enable this feature
  /*
  if (benefitButtons.length > 0) {
    const firstButton = benefitButtons[0];
    const firstContent = firstButton.nextElementSibling;
    
    firstButton.classList.add('active');
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
  }
  */
});